@use "~theme/breakpoints";
@use "~theme/typography";

.pageContainer {
  display: flex;
  flex: 1 1;
  flex-flow: column;
  margin: 32px 0 0;

  @include breakpoints.desktop {
    flex-flow: row;
    margin: 0;
  }
}

.currentAction {
  padding: 24px var(--mobile-gutter) 36px var(--mobile-gutter);
  width: 100%;

  @include breakpoints.desktop {
    padding: 48px var(--desktop-gutter) 36px var(--desktop-gutter);
    max-width: calc(365px + 2 * var(--desktop-gutter));
  }
}

.currentActionHeader {
  margin-bottom: 60px;
}

.steps {
  display: flex;
  flex-direction: column;
  row-gap: 1px;

  background-color: var(--blue-01-at-30);
  border-top: 1px solid var(--blue-01-at-30);
  border-bottom: 1px solid var(--blue-01-at-30);

  @include breakpoints.desktop {
    flex-grow: 1;
    max-width: 50vw;
    margin-left: auto;
    border-top: none;
    border-bottom: none;
    border-left: 1px solid var(--blue-01-at-30);

    > * {
      flex-grow: 1;
    }
  }
}

.preheading {
  @include typography.heading2;
  margin: 0 0 10px;
}

.heading {
  @include typography.heading1;
  margin: 0 0 8px;

  @include breakpoints.desktop {
    margin-bottom: 24px;
  }
}

@mixin aside-icon($img-url) {
  &::before {
    background-image: $img-url;
    content: "";
    margin-right: 6px;
    height: 24px;
    width: 24px;
  }
}

.aside {
  display: inline-flex;
  align-items: center;
  color: var(--black-at-75);
}

.asideStopwatch {
  @include aside-icon(url("~images/stopwatch.svg"));
}

.asidePiggyBank {
  @include aside-icon(url("~images/piggy-bank.svg"));
}

.asideClipboardClock {
  @include aside-icon(url("~images/clipboard-clock-small.svg"));
}

.actionText {
  @include typography.body-large;
}

.action {
  display: flex;
  margin-top: 24px;
  width: 100%;
}
